var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconoir:cancel"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00781 22.7166L15.6765 16.0479L22.3452 22.7166M22.3452 9.37915L15.6752 16.0479L9.00781 9.37915",
    stroke: "black",
    strokeWidth: 1.90789,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirCancel);
export default __webpack_public_path__ + "static/media/iconoir_cancel.65c932e023c1887ced4c638a3f32bb79.svg";
export { ForwardRef as ReactComponent };